<script>
export default {
  name: "ImageComponent",
  props: {
    imageSrc: {
      type: String,
      required: true
    }
  }
}
</script>

<template>
  <div class="image">
    <img :src="imageSrc" />
  </div>
</template>

<style scoped>

.image {
  display: inline-block;
  vertical-align: middle;
}

.image {
  width: 30%;
}

</style>
